import {
    VuexModule,
    Module,
    Mutation,
    Action,
    getModule,
} from 'vuex-module-decorators'
import store from '@/store'
import { Image } from '@/types/image'
import queryString from 'query-string'
import memoize from 'lodash/memoize'

// julien.muret@keole.net
const API_KEY = '11825257-517b3a87a61bf44e03e259a48'
const PER_PAGE = 40

const memoizedSearch = memoize(search)
async function search(input: string): Promise<Image[]> {
    const base = {
        key: API_KEY,
        per_page: PER_PAGE,
    }
    const query = {
        ...base,
        q: input,
    }
    const queryStr = queryString.stringify(query)

    const url = `https://pixabay.com/api/?${queryStr}`

    const resp = await fetch(url)
    const data = await resp.json()
    const images = data.hits

    return images
}

interface PixabayState {
    loading: boolean
    searchStr: string
    images: Image[]
    selectedImage: Image | null
}

@Module({ dynamic: true, store, name: 'pixabay', namespaced: true })
class PixabayModule extends VuexModule implements PixabayState {
    public loading = false
    public searchStr = ''
    public images = []
    public selectedImage = null

    @Mutation
    private setLoading(loading: boolean) {
        this.loading = loading
    }

    @Mutation
    private setImages(images: Image[]) {
        this.images = images
    }

    @Mutation
    private setSearchStr(searchStr: string) {
        this.searchStr = searchStr
    }

    @Mutation
    private setSelectedImage(selectedImage: null) {
        this.selectedImage = selectedImage
    }

    @Action
    async search(input: string) {
        this.context.commit('setLoading', true)

        const images = await memoizedSearch(input)

        this.context.commit('setSearchStr', input)
        this.context.commit('setImages', images)
        this.context.commit('setLoading', false)
    }

    @Action
    async setSelectedImageAction(image: Image) {
        this.context.commit('setSelectedImage', image)
    }

    @Action
    async cleanup() {
        this.cleanupImages()
        this.context.commit('setSearchStr', '')
        this.context.commit('setSelectedImage', null)
    }

    @Action
    async cleanupImages() {
        this.context.commit('setImages', [])
    }
}

export default getModule(PixabayModule)
